import { FillLayer } from "mapbox-gl";

const HullFillLayer: FillLayer = {
  id: "hull-fill-layer",
  type: "fill",
  paint: {
    "fill-color": "steelblue",
    "fill-opacity": 0.5
  }
}

export { HullFillLayer }
